import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { PrivateRoutes } from "./PrivateRoutes";
import SchedulePage from '../pages/SchedulePage';
import AppBar from '../components/AppBar';
import ShowResultsPage from '../pages/ShowResultsPage';
import ShowResultPage from '../pages/ShowResultPage';
import StandingsPage from '../pages/StandingsPage';
import SponsorsPage from '../pages/SponsorsPage';
import ArenasPage from '../pages/ArenasPage';
import AboutPage from '../pages/AboutPage';
import RiderResultPage from '../pages/RiderResultPage';
import FeatureGate from '../components/FeatureGate';
import { FEATURE_KEYS } from '../models/FeatureFlags';

export const AppRouter = () => {
  return (
    <BrowserRouter>
      <AppBar />
      <Routes>
        {/* Public Routes */}
        <Route path="/schedule" element={<SchedulePage />} />
        <Route path="/showResults" element={<ShowResultsPage />} />
        <Route path="/showResults/:showId" element={<ShowResultPage />} />
        <Route
          path="/riderResults"
          element={
            <FeatureGate featureKey={FEATURE_KEYS.riderResults}>
              <RiderResultPage />
            </FeatureGate>
          }
        />
        <Route path="/standings" element={<StandingsPage />} />
        <Route path="/sponsors" element={<SponsorsPage />} />
        <Route path="/arenas" element={<ArenasPage />} />
        <Route path="/about" element={<AboutPage />} />
        
        {/* Private Routes */}
        <Route path="/admin/*" element={<PrivateRoutes />} />
        
        <Route path="*" element={<Navigate to="/schedule" replace />} />
      </Routes>
    </BrowserRouter>
  );
};
